import { render, staticRenderFns } from "./ModalPageAlmoxarifadoItemBemConsumo.vue?vue&type=template&id=df2954c8"
import script from "./ModalPageAlmoxarifadoItemBemConsumo.vue?vue&type=script&lang=js"
export * from "./ModalPageAlmoxarifadoItemBemConsumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports